<!-- Mobile: flat lists grouped by section -->
@if (mobile) {

    <!-- Shop All / Featured / MHP quick links -->
    <ul class="dotcom-mobile-nav__sub-list">
        <li class="dotcom-mobile-nav__sub-item">
            <a class="dotcom-mobile-nav__sub-link"
               [routerLink]="catalogRoute(-1)"
               (click)="navigate()"
               translate="cart.shop.all.products"></a>
        </li>
        <li class="dotcom-mobile-nav__sub-item">
            <a class="dotcom-mobile-nav__sub-link"
               [routerLink]="landingRoute"
               (click)="navigate()"
               translate="cart.shop.home"></a>
        </li>
        @if (showBuildMhpLink) {
            <li class="dotcom-mobile-nav__sub-item">
                <a class="dotcom-mobile-nav__sub-link"
                   [routerLink]="mhpRoute"
                   (click)="navigate()"
                   translate="cart.myhealthpak"></a>
            </li>
        }
    </ul>

    <!-- Lifestyles -->
    @if ((lifestyles$ | async)?.length > 0) {
        <p class="dotcom-mobile-nav__section-label" translate="cart.shop.by.lifestyle"></p>
        <ul class="dotcom-mobile-nav__sub-list">
            @for (group of lifestyles$ | async; track group.id) {
                @for (navItem of group.children; track navItem.id) {
                    @if (navItem.navDisplay) {
                        <li class="dotcom-mobile-nav__sub-item">
                            <a class="dotcom-mobile-nav__sub-link"
                               [routerLink]="tagRoute(navItem.id)"
                               (click)="navigate()"
                               [translate]="navItem.translationTag"></a>
                        </li>
                    }
                }
            }
        </ul>
    }
    <!-- Categories -->
    <p class="dotcom-mobile-nav__section-label" translate="cart.shop.by.category"></p>
    <ul class="dotcom-mobile-nav__sub-list">
        @for (navItem of nav$ | async; track navItem.id) {
            <li class="dotcom-mobile-nav__sub-item">
                <a class="dotcom-mobile-nav__sub-link"
                   [routerLink]="catalogRoute(navItem.id)"
                   (click)="navigate()"
                   [translate]="navItem.translationTag"></a>
            </li>
        }
    </ul>
    <!-- Body Benefits -->
    @if ((bodyBenefits$ | async)?.length > 0) {
        <p class="dotcom-mobile-nav__section-label" translate="cart.shop.by.body.benefit"></p>
        <ul class="dotcom-mobile-nav__sub-list">
            @for (group of bodyBenefits$ | async; track group.id) {
                @if (group.navDisplay) {
                    @for (subNavItem of group.children; track subNavItem.id) {
                        @if (subNavItem.navDisplay) {
                            <li class="dotcom-mobile-nav__sub-item">
                                <a class="dotcom-mobile-nav__sub-link"
                                   [routerLink]="tagRoute(subNavItem.id)"
                                   (click)="navigate()"
                                   [translate]="subNavItem.translationTag"></a>
                            </li>
                        }
                    }
                }
            }
        </ul>
    }


<!-- Desktop: mirrors the main-header shop dropdown layout exactly -->
} @else {
    <div class="category-dropdown">

        <!-- Lifestyle section — left column with right border -->
        @if ((lifestyles$ | async)?.length > 0) {
            <div class="flex-col nav-lifestyle">
                <h5 class="category-group-header" translate="cart.shop.by.lifestyle"></h5>
                @for (group of lifestyles$ | async; track group.id) {
                    <ul class="category-link-list">
                        @for (navItem of group.children; track navItem.id) {
                            @if (navItem.navDisplay) {
                                <li>
                                    <a [routerLink]="tagRoute(navItem.id)"
                                       (click)="navigate()"
                                       [translate]="navItem.translationTag"></a>
                                </li>
                            }
                        }
                    </ul>
                }
                <a class="nav-lifestyle__shop-home"
                   [routerLink]="landingRoute"
                   (click)="navigate()"
                   translate="cart.shop.home"></a>
            </div>
        }

        <!-- Categories section — centre column, one group per top-level category -->
        <div class="flex-col nav-erp">
            <h5 class="category-group-header" translate="cart.shop.by.category"></h5>
            <div class="flex-category-wrapper">
                @for (navItem of nav$ | async; track navItem.id) {
                    <div class="category-link-group">
                        <a class="group-title"
                           [routerLink]="catalogRoute(navItem.id)"
                           (click)="navigate()"
                           [translate]="navItem.translationTag"></a>
                        <ul class="category-link-list">
                            @for (subNavItem of navItem.children; track subNavItem.id) {
                                <li>
                                    <a [routerLink]="catalogRoute(subNavItem.id)"
                                       (click)="navigate()"
                                       [translate]="subNavItem.translationTag"></a>
                                </li>
                            }
                        </ul>
                    </div>
                }
            </div>
        </div>

        <!-- Body benefits section — right column with left border, two-column grid of links -->
        @if ((bodyBenefits$ | async)?.length > 0) {
            @for (group of bodyBenefits$ | async; track group.id) {
                <div class="flex-col nav-body-benefits">
                    <h5 class="category-group-header" translate="cart.shop.by.body.benefit"></h5>
                    @if (group.navDisplay) {
                        <div class="flex-category-wrapper">
                            <ul class="category-link-list">
                                @for (subNavItem of group.children; track subNavItem.id) {
                                    @if (subNavItem.navDisplay) {
                                        <li class="categoryLink nested">
                                            <a [routerLink]="tagRoute(subNavItem.id)"
                                               (click)="navigate()"
                                               [translate]="subNavItem.translationTag"></a>
                                        </li>
                                    }
                                }
                            </ul>
                        </div>
                    }
                </div>
            }
        }

        <!-- Shop All Products / My Health Pak — full-width footer row with top border -->
        <div class="nav-shop-all">
            <a class="d-block"
               [routerLink]="catalogRoute(-1)"
               (click)="navigate()"
               translate="cart.shop.all.products"></a>
            @if (showBuildMhpLink) {
                <a class="d-block"
                   [routerLink]="mhpRoute"
                   (click)="navigate()"
                   translate="cart.myhealthpak"></a>
            }
        </div>

    </div>
}
